module.exports = __webpack_public_path__ + "img/DTA.f77221b2.svg";